import { requestV2 } from 'store/common/utils';
// добавляет ссылки на видео в проекте
export const createProjectVideoLinksApi = (projectId, data) => requestV2({
    url: `/projects/${projectId}/video-links`,
    method: 'POST',
    data,
    headers: { 'x-api-scope': 'admin' },
});
// редактирует ссылки на видео в проекте
export const editProjectVideoLinksApi = (projectId, data) => requestV2({
    url: `/projects/${projectId}/video-links`,
    method: 'PUT',
    data,
    headers: { 'x-api-scope': 'admin' },
});
// сортирует ссылки на видео в проекте
export const sortProjectVideoLinksApi = (projectId, data) => requestV2({
    url: `/projects/${projectId}/video-links/sort`,
    method: 'PUT',
    data,
    headers: { 'x-api-scope': 'admin' },
});
// удаляет ссылки на видео в проекте
export const deleteProjectVideoLinksApi = (projectId, data) => requestV2({
    url: `/projects/${projectId}/video-links/delete-batch`,
    method: 'POST',
    data,
    headers: { 'x-api-scope': 'admin' },
});
